import { render } from "./InstituteComponent.vue?vue&type=template&id=f772b08c"
import script from "./InstituteComponent.vue?vue&type=script&lang=js"
export * from "./InstituteComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__